import { EndRide } from './EndRide';
import { AuthService } from './../../shared/models/auth.service';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { LockUnlock } from './lockunlock.model';
import { LockUnlockResult } from './lockunlockresult.model';
import { StartRide } from './../models/StartRide';

@Injectable()
export class UnlockService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public UnlockVehicle(lockUnlock: LockUnlock) {
    let body = lockUnlock;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_UnLOCK, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public StartTrip(startride: StartRide) {
    let body = startride;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_STARTRIDE, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetContactTypeGroupList(bookingHashId: string): Observable<IAPIResponse> {
    let getcontacttypegrouplist = WeGoConfig.API_CONTACTYPE_LIST + "?bookingHashId=" + bookingHashId;
    let queryString = this.authService.HandleAPIListInput();

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getcontacttypegrouplist, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public PartialLock(lockUnlock: LockUnlock) {
    let body = lockUnlock;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_PARTIALLOCK, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public LockVehicle(lockUnlock: LockUnlock) {
    let body = lockUnlock;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_LOCK, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public EndTrip(endride: EndRide)
  {
     let body = endride;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_ENDRIDE, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/unlock.service.ts